
module.exports = {
    // baseurl: "/property-owners-guyana/",
    // baseurl: "http://localhost:3001/",
    baseurl: "/",    
    loginurl: 'staffdashboard',
    loginurluser: 'userdashboard',
    uservehicle: 'uservehicle',
    explorer: 'explorer',
    }